import { useGetEmployeeQuery } from "../../../app/features/employee/employee.api";
import useAuth from "../../../hooks/useAuth";
import useError from "../../../hooks/useError";
import UserLayout from "../../../layouts/user";
import CVInfo from "./_components/CVInfo";
import Divider from "./_components/Divider";
import EducationInfo from "./_components/EducationInfo";
import ExperienceInfo from "./_components/ExperienceInfo";
import GeneralInformation from "./_components/GeneralInformation";
import PassportInfo from "./_components/PassportInfo";
import ProfileHeader from "./_components/ProfileHeader";
import TechnicalInfo from "./_components/TechnicalInfo";

const breadcrumb = [
  {
    title: "হোম",
    path: "/",
  },
  {
    title: "ড্যাশবোর্ড",
  },
];

export default function UserProfile() {
  const { employee } = useAuth();
  const {
    error,
    data: employeeData,
    isLoading,
  } = useGetEmployeeQuery(employee?.id || 0, {
    skip: !employee?.id,
  });
  useError(error, "Failed to load employee data");

  return (
    <UserLayout title="আমার প্রোফাইল" breadcrumb={breadcrumb}>
      <div className="p-6 rounded-xl border border-theme-zinc-200 space-y-6">
        <ProfileHeader data={employeeData} loading={isLoading} />
        <Divider />
        <GeneralInformation data={employeeData} loading={isLoading} />
        <Divider />
        <PassportInfo data={employeeData} loading={isLoading} />
        <Divider />
        <EducationInfo data={employeeData} loading={isLoading} />
        <Divider />
        <TechnicalInfo data={employeeData} loading={isLoading} />
        <Divider />
        <ExperienceInfo data={employeeData} loading={isLoading} />
        <Divider />
        <CVInfo data={employeeData} loading={isLoading} />
      </div>
    </UserLayout>
  );
}
